import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliUmListPage.vue?vue&type=template&id=6a1b2c93"
import script from "./ConfigurazioniMagazzinoArticoliUmListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliUmListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports